// Phones and small touch tablets. The viewer's mobile clamp (main.js), the
// phone-sized textures (src/textureFormat.js) and the streamed imagery's
// smaller atlases (src/rocketry/*imagery.js) all key off this one test, so a
// device is either on the phone budget everywhere or nowhere. Measured in
// docs/mobile-memory.md.
export function isMobileLikeDevice() {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const touchDevice = navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
    || (touchDevice && Math.min(window.innerWidth || 0, window.innerHeight || 0) < 1024);
}

export const RUNNING_ON_MOBILE = isMobileLikeDevice();

// A phone or small tablet held sideways: wider than the phone layouts'
// widths but too short for a side panel. Desktops never report a coarse
// pointer.
export const SHORT_TOUCH_QUERY = '(pointer: coarse) and (max-height: 600px)';

// The viewer's phone layout (index.html, which writes it out in full):
// narrow screens, and phones held sideways.
export const COMPACT_LAYOUT_QUERY = `(max-width: 820px), ${SHORT_TOUCH_QUERY}`;

// A loaded model's textures shrunk in place to maxDim on the long edge,
// before their first upload: on a phone's canvas a station or a rock is a
// few hundred pixels across, and each 1024 map with its mips is 5.3 MB.
export function shrinkModelTextures(root, maxDim) {
  if (!root || typeof document === 'undefined') return;
  const seen = new Set();
  root.traverse((node) => {
    const materials = !node.material ? [] : Array.isArray(node.material) ? node.material : [node.material];
    for (const material of materials) {
      for (const key of Object.keys(material)) {
        const texture = material[key];
        if (!texture || !texture.isTexture || seen.has(texture)) continue;
        seen.add(texture);
        const image = texture.image;
        const w = image && (image.naturalWidth || image.width), h = image && (image.naturalHeight || image.height);
        if (!w || !h || Math.max(w, h) <= maxDim) continue;
        const scale = maxDim / Math.max(w, h);
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(w * scale));
        canvas.height = Math.max(1, Math.round(h * scale));
        const ctx = canvas.getContext('2d');
        if (!ctx) continue;
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        texture.image = canvas;
        texture.needsUpdate = true;
        if (typeof image.close === 'function') image.close();
      }
    }
  });
}
